import { useState } from 'react';

const useTableSelection = (data, filteredColumnsList, columns, tableRef) => {
  const customBackGroundColor = 'rgba(115, 194, 251, 0.3)';
  const [isMouseDown, setIsMouseDown] = useState(false);
  const [firstSelectedCell, setFirstSelectedCell] = useState(null);

  const cellMouseDown = (rowIndex, columnIndex) => {
    setIsMouseDown(true);
    const newFirstSelectedCell = { row: rowIndex, col: columnIndex };
    setFirstSelectedCell(newFirstSelectedCell);
    cellClick(rowIndex, columnIndex, newFirstSelectedCell);
  };

  const cellMouseEnter = (rowIndex, columnIndex) => {
    if (isMouseDown) {
      cellClick(rowIndex, columnIndex);
    }
  };

  const cellMouseUp = () => {
    setIsMouseDown(false);
  };

  const toCamelCase = (str) =>
    str
      .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
        index === 0 ? word.toLowerCase() : word.toUpperCase()
      )
      .replace(/\s+/g, '');

  const isColumnValid = (rowIndex, columnIndex) => {
    const dateRegex = /^[0-9]{1}[5-7]{1}[0-9]{11}$/;
    // const phoneNumberRegex =
    //   /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
    let valid = true;
    const column = toCamelCase(filteredColumnsList[columnIndex]);
    valid =
      data[rowIndex][column] !== '' &&
      !Number.isNaN(
        /// is number checking
        +data[rowIndex][column]
      );

    if (valid) {
      // is date checking
      valid = !dateRegex.test(data[rowIndex][column]);
    }

    // if (valid) {
    //   // is phoneNumber checking
    //   valid = !phoneNumberRegex.test(data[rowIndex][column]);
    // }

    if (valid) {
      // is column calculationIgnored checking
      valid = !columns[filteredColumnsList[columnIndex]]?.calculationIgnored;
    }

    return valid;
  };

  const cellClick = (rowIndex, columnIndex, firstCell) => {
    const cell = tableRef.current.querySelector(
      `#cell-${rowIndex}-${columnIndex}`
    );
    if (cell.style.backgroundColor !== customBackGroundColor) {
      cell.style.backgroundColor = customBackGroundColor;
      setAllOtherCellsBackgroundToBlue(rowIndex, columnIndex, firstCell);
    } else {
      setAllCellsBackgroundToTransparent();
      setAllOtherCellsBackgroundToBlue(rowIndex, columnIndex);
    }
  };

  const setAllOtherCellsBackgroundToBlue = (
    rowIndex,
    columnIndex,
    firstCell = undefined
  ) => {
    let minRow;
    let maxRow;
    let minCol;
    let maxCol;
    if (firstCell !== undefined) {
      minRow = Math.min(firstCell.row, rowIndex);
      maxRow = Math.max(firstCell.row, rowIndex);
      minCol = Math.min(firstCell.col, columnIndex);
      maxCol = Math.max(firstCell.col, columnIndex);
    } else {
      minRow = Math.min(firstSelectedCell.row, rowIndex);
      maxRow = Math.max(firstSelectedCell.row, rowIndex);
      minCol = Math.min(firstSelectedCell.col, columnIndex);
      maxCol = Math.max(firstSelectedCell.col, columnIndex);
    }
    const newSelectedRows = [];
    for (let i = minRow; i <= maxRow; i++) {
      newSelectedRows.push(i);
    }

    const newSelectedCols = [];
    for (let i = minCol; i <= maxCol; i++) {
      newSelectedCols.push(i);
    }
    newSelectedRows.forEach((row) => {
      newSelectedCols.forEach((col) => {
        const cell = tableRef.current.querySelector(`#cell-${row}-${col}`);
        if (cell) {
          cell.style.backgroundColor = customBackGroundColor;
        }
      });
    });
  };

  const setAllCellsBackgroundToTransparent = () => {
    const rows = tableRef.current.querySelectorAll('tbody tr'); // Select all rows in the table body
    rows.forEach((row) => {
      const cells = row.querySelectorAll('td'); // Select all cells in the current row
      cells.forEach((cell) => {
        //   if (rowIndex === targetRowIndex || colIndex === targetColIndex) {
        cell.style.background = 'transparent'; // Apply style if conditions are met
        //   }
      });
    });
  };

  return {
    cellMouseDown,
    cellMouseEnter,
    cellMouseUp,
    toCamelCase,
    isColumnValid,
    setAllCellsBackgroundToTransparent
  };
};

export default useTableSelection;
